module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-18.206e6d1c.mp3";